{
  "pending": "în așteptare"
}
